
define('tpl!taoQtiItem/qtiCreator/tpl/interactions/matchInteraction.row', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", self=this, helperMissing=helpers.helperMissing;

function program1(depth0,data) {
  
  
  return "\n    <td>\n        <label>\n            <input type=\"checkbox\" >\n            <span class=\"icon-checkbox cross\"></span>\n        </label>\n    </td>\n    ";
  }

  buffer += "<tr>\n    ";
  if (helper = helpers.choice) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.choice); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  stack1 = (helper = helpers['for'] || (depth0 && depth0['for']),options={hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, 0, (depth0 && depth0.otherMatchSetCount), 1, options) : helperMissing.call(depth0, "for", 0, (depth0 && depth0.otherMatchSetCount), 1, options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</tr>";
  return buffer;
  });
});

